// Module
var code = "Help Template";
// Exports
export default code;